export const PERIODS = ["Day", "Month", "Year", "All"];

export const isInPeriod = (dateStr, period, referenceDate = new Date()) => {
  const d = new Date(`${dateStr}T00:00:00`);
  if (period === "Day") {
    return d.toDateString() === referenceDate.toDateString();
  }
  if (period === "Month") {
    return d.getFullYear() === referenceDate.getFullYear() && d.getMonth() === referenceDate.getMonth();
  }
  if (period === "Year") {
    return d.getFullYear() === referenceDate.getFullYear();
  }
  return true;
};

export const periodLabel = (period) => {
  if (period === "Day") return "Today";
  if (period === "Month") return "This Month";
  if (period === "Year") return "This Year";
  if (period === "All") return "All Time";
  return period;
};
